<style src='./style.scss'>

</style>

<footer class="mbsc-col-12 mbsc-align-right">
  <header>
    <ul>
      <li>
        <a target="_blank" href="https://www.facebook.com/team.dns.studio">
          <picture>
            <img src="/images/fb-white-30.png" alt="Facebook Page">
          </picture>
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.instagram.com/team.dns.studio">
          <picture>
            <img src="/images/ig-white-30.png" alt="Instagram">
          </picture>
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.youtube.com/channel/UC_UJ6x0W0-SWR-TPgKmYWSA">
          <picture>
            <img src="/images/yt-white-30.png" alt="Youtube">
          </picture>
        </a>
      </li>
      <li>
        <a target="_blank" href="https://twitter.com/team_dns_studio">
          <picture>
            <img src="/images/tw-white-30.png" alt="Twitter">
          </picture>
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.tiktok.com/@team.dns.studio">
          <picture>
            <img src="/images/tt-white-30.png" alt="Tik Tok">
          </picture>
        </a>
      </li>
    </ul>
    <p>Copyright D-NS Studio ©{curYear.getFullYear()}</p>
  </header>
</footer>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  const dispatch = createEventDispatcher();

  const curYear = new Date();

  onMount(async () =>{});
</script>